(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .constant('FILTER_GROUP', {
            BEHAVIOR: 'BEHAVIOR',
            CHARACTERISTIC: 'CHARACTERISTIC'
        });

    angular
        .module('showcaseApp')
        .constant('FILTER_CSS_CLASS', {
            BEHAVIOR: 'behavior',
            CHARACTERISTIC: 'characteristic'
        });

})();
